// extracted by mini-css-extract-plugin
export var body = "c35EJtajqgKGmUt0Y1xQ";
export var hero = "ww1CMpTOOwbDdA3BnGBs";
export var large = "xQXzPlnPBhhZ8IUcmaxI";
export var micro = "x8731h2oez1o4IPuBB6q";
export var mini = "W_c2ZYhet9Js13JRkBAy";
export var small = "s4VMNj4NLtocapOUwGaU";
export var title1 = "y6ZSA9SxIZj4gpmEiwbJ";
export var title2 = "txlNcTCOZRvSAg8XXwvA";
export var title3 = "_0e4xZPvg_2__FIoOeYM";